import { createContext, useContext } from 'react';
import type { League } from '@/types/league';

/**
 * Shared state for the league detail layout (`/matches/:leagueId/*`).
 * The league record is fetched once in the layout; tabs read it here.
 */
export interface LeagueDetailContextType {
  league: League;
  leagueId: string;
}

export const LeagueDetailContext = createContext<LeagueDetailContextType | undefined>(undefined);

export function useLeagueDetailContext() {
  const ctx = useContext(LeagueDetailContext);
  if (!ctx) {
    throw new Error('useLeagueDetailContext must be used within LeagueDetailLayout');
  }
  return ctx;
}
